import React from 'react';
import { Building2, Dumbbell, Heart, ArrowRight } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { useTranslation } from '../../i18n';

const HeroSection = ({ setShowRegistrationModal, openLoginModal, setKnowSection }) => {
  const { t } = useTranslation();
  return (
    <section className="pt-24 sm:pt-32 pb-12 sm:pb-20 px-4 sm:px-6 lg:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div>
            <p className="text-sm sm:text-base text-slate-600 italic leading-relaxed mb-4 sm:mb-6 max-w-lg" style={{ fontFamily: 'Georgia, serif' }}>
              &nbsp;
            </p>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-slate-900 tracking-tight leading-none mb-4 sm:mb-6" style={{ fontFamily: 'Chivo, sans-serif' }}>
              {t('hero.titleA')}
              <span className="text-blue-600"> {t('hero.titleB')}</span>
            </h1>
            <p className="text-base sm:text-lg text-slate-600 leading-relaxed mb-6 sm:mb-8 max-w-lg">
              {t('hero.subtitle')}
            </p>
            <div className="grid grid-cols-3 gap-2 sm:gap-3 mb-6" data-testid="hero-know-buttons">
              <button onClick={() => { const s = document.querySelector('[data-testid="know-our-system-section"]'); s?.scrollIntoView({ behavior: 'smooth' }); setKnowSection('empresa'); }}
                className="flex flex-col items-center gap-1 px-2 py-3 rounded-xl bg-white shadow-md hover:shadow-lg border border-slate-100 transition-all text-center group hover:-translate-y-0.5">
                <Building2 className="w-5 h-5 text-blue-600" />
                <span className="text-[10px] sm:text-xs font-bold text-blue-700 leading-tight">{t('hero.ctaCompany')}</span>
              </button>
              <button onClick={() => { const s = document.querySelector('[data-testid="know-our-system-section"]'); s?.scrollIntoView({ behavior: 'smooth' }); setKnowSection('academia'); }}
                className="flex flex-col items-center gap-1 px-2 py-3 rounded-xl bg-white shadow-md hover:shadow-lg border border-slate-100 transition-all text-center group hover:-translate-y-0.5">
                <Dumbbell className="w-5 h-5 text-orange-500" />
                <span className="text-[10px] sm:text-xs font-bold text-orange-600 leading-tight">{t('hero.ctaGym')}</span>
              </button>
              <button onClick={() => { const s = document.querySelector('[data-testid="know-our-system-section"]'); s?.scrollIntoView({ behavior: 'smooth' }); setKnowSection('voce'); }}
                className="flex flex-col items-center gap-1 px-2 py-3 rounded-xl bg-white shadow-md hover:shadow-lg border border-slate-100 transition-all text-center group hover:-translate-y-0.5">
                <Heart className="w-5 h-5 text-emerald-600" />
                <span className="text-[10px] sm:text-xs font-bold text-emerald-700 leading-tight">{t('hero.ctaYou')}</span>
              </button>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
              <Button
                onClick={() => setShowRegistrationModal(true)}
                data-testid="hero-cta-button"
                size="lg"
                className="bg-slate-900 text-white hover:bg-slate-800 shadow-lg transition-transform hover:-translate-y-0.5 px-8"
              >
                {t('hero.ctaStart')}
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
              <Button
                variant="outline"
                size="lg"
                onClick={openLoginModal}
                className="border-slate-200 hover:bg-slate-50"
              >
                {t('hero.ctaHaveAccount')}
              </Button>
            </div>
          </div>
          <div className="relative mt-4 lg:mt-0">
            <div className="absolute -inset-4 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-2xl blur-2xl opacity-20"></div>
            <img
              src="https://static.prod-images.emergentagent.com/jobs/1b73f472-c1c6-444f-9096-a23524fc96e5/images/7e6f1d59eef2bc07364076d90e53d280c0f34643efbaf59f7391d4aad548364b.png"
              alt="Mesa de escritorio com notebook e maca"
              className="relative rounded-2xl shadow-2xl w-full object-cover aspect-[4/3]"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
